import { Tag, Tooltip } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import styles from "./style.module.scss";
import SquareInfoIcon from "assets/icons/SquareInfoIcon";
export type StatusColor = "success" | "processing" | "warning" | "error";

export interface StatusCellTooltip {
  title?: string;
  text: string;
}
interface StatusCellProps {
  color: StatusColor;
  text: string;
  loading?: boolean;
  tooltip?: StatusCellTooltip;
}

const BulletIcon = () => <span className={styles.bulletIcon} />;

export default function StatusCell({
  color,
  text,
  loading,
  tooltip,
}: StatusCellProps) {
  return (
    <div className={styles.tagWrapper}>
      <Tag color={color} variant="filled" className={styles.tag}>
        <div>
          {loading ? (
            <LoadingOutlined className={styles.loadingIcon} spin />
          ) : (
            <BulletIcon />
          )}
        </div>
        <div>{text}</div>
      </Tag>
      {tooltip && (
        <Tooltip
          title={
            <div className={styles.tooltipContent}>
              {tooltip.title && (
                <div className={styles.tooltipTitle}>{tooltip?.title}</div>
              )}
              <div className={styles.tooltipDescription}>{tooltip?.text}</div>
            </div>
          }
        >
          <div className={styles.infoIcon}>
            <SquareInfoIcon />
          </div>
        </Tooltip>
      )}
    </div>
  );
}
